import { render, staticRenderFns } from "./PatientVaccinations.vue?vue&type=template&id=7f632f1c&scoped=true&"
import script from "./PatientVaccinations.vue?vue&type=script&lang=js&"
export * from "./PatientVaccinations.vue?vue&type=script&lang=js&"
import style0 from "./PatientVaccinations.vue?vue&type=style&index=0&id=7f632f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f632f1c",
  null
  
)

export default component.exports